/**
 * Capitalizes the first letter of a string.
 * Returns an empty string if input is null/undefined/empty.
 */
export function capitalizeFirst(value: string | null | undefined): string {
  if (!value) {
    return "";
  }
  return value.charAt(0).toUpperCase() + value.slice(1);
}

/**
 * Generates a short, random, alphanumeric string.
 *
 * The string is created by converting a random decimal number (from `Math.random()`)
 * to base 36 (0-9, a-z) and taking a substring of 7 characters.
 * 
 * Example output: "5gk8q2z"
 * 
 * @returns {string} A random alphanumeric string of 5–7 characters.
 */
export function uniqueId(): string {
    // eslint-disable-next-line sonarjs/pseudo-random
    return Math.random().toString(36).substring(2, 9);
}

export function isNullOrEmpty(str: string | null | undefined): boolean {
    return !str || str === "";
}

export function isEmptyOrWhiteSpace(str: string): boolean {
    return str.replace(/\s/g, "") === "";
}

export function isNullOrEmptyOrWhiteSpace(str: string | undefined | null): boolean {
    if (!str) {
        return true;
    }

    return isEmptyOrWhiteSpace(str);
}

export function normalizeGuid(guid: string): string {
    return guid.toUpperCase().replace("{", "").replace("}", "");
}

export function trimEnd(endToTrim: string, from: string, ignoreCase = false): string {
    if (endToTrim === "") {
        return from;
    }

    if (from === "") {
        return "";
    }

    const endToTrimUpper: string = endToTrim.toUpperCase();
    let fromUpper: string = from.toUpperCase();

    while (from.endsWith(endToTrim) || (ignoreCase && fromUpper.endsWith(endToTrimUpper))) {
        const lastIndex = fromUpper.lastIndexOf(endToTrimUpper);
        from = from.substring(0, lastIndex);
        fromUpper = from.toUpperCase();
    }

    return from;
}